import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Rating } from 'react-simple-star-rating';
import { api_getReviews } from '~/backend/api_calls';
import UserSession from '~/backend/user_session';

const ProductRating = ({ product, handleOpenReviewModal }) => {
	const { t } = useTranslation();
	const [rating, setRating] = useState(0);
	const [review, setReview] = useState('');
	const [ownReview, setOwnReview] = useState(null);

	useEffect(() => {
		const fetchReviews = async () => {
			try {
				const data = await api_getReviews(1, product.id);

				const userId = UserSession.getId();
				const userReview = data?.items?.find(x => x.from_id === parseInt(userId));
				if (userReview) {
					setRating(userReview.rating || 0);
					setReview(userReview.review || '');
					setOwnReview(userReview);
				}
			} catch (err) {
				console.error(err);
			}
		};
		fetchReviews();
	}, [product]);

	return (
		<div className="reviews">
			<Rating
				allowFraction
				fillColor="black"
				SVGstrokeColor="black"
				size={18}
				style={{ height: '16px' }}
				readonly
				initialValue={product?.aggregates?.rating ?? 0}
			/>
			<small>({product?.aggregates?.reviews ?? 0})</small>
			{ownReview ? (
				<span className=" read write" onClick={handleOpenReviewModal}>
					{t('rating.readReview')}
				</span>
			) : (
				<span className=" read write" onClick={handleOpenReviewModal}>
					{t('rating.writeReview')}
				</span>
			)}
		</div>
	);
};

export default ProductRating;
